// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input[type=email][data-v-048eee8e]{border:3px solid #0384fb;box-sizing:border-box}", "",{"version":3,"sources":["webpack://./app/forms/components/Email.vue"],"names":[],"mappings":"AACA,mCACI,wBAAA,CACA,qBAAA","sourcesContent":["\ninput[type=email] {\n    border: 3px solid #0384FB;\n    box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
